export default __webpack_public_path__ + "static/media/nav-setting-icon.efca409d.svg";